import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Timeline } from "@/components/Timeline";
import { Machinery } from "@/components/Machinery";
import { Capabilities } from "@/components/Capabilities";
import { Rettifica } from "@/components/Rettifica";
import { Services } from "@/components/Services";
import { Sectors } from "@/components/Sectors";
import { Brands } from "@/components/Brands";
import { Infrastructure } from "@/components/Infrastructure";
import { Quality } from "@/components/Quality";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain bg-zinc-950 text-white">
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { borderRadius: 0, background: "#18181b", border: "1px solid #27272a", color: "#fff" } }} />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Timeline />
        <Machinery />
        <Capabilities />
        <Services />
        <Rettifica />
        <Sectors />
        <Brands />
        <Infrastructure />
        <Quality />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
